const trueValue = require("true-value")
const falseValue = require("false-value")

module.exports = [trueValue(), falseValue()]